import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Layout, Users, Plus, Truck } from 'react-feather';
import PropTypes from 'prop-types';
import './QRNav.css';

const QRNav = ({ activeTabId, subtitle, addButtonText, onAddClick, onTabChange }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const tabs = [
        { id: 'tables', label: 'Tables', path: '/tables-new', icon: <Layout size={16} /> },
        { id: 'clients', label: 'Clients', path: '/clients', icon: <Users size={16} /> },
        { id: 'vad', label: 'Ventes à distance', path: '/ventes-distance', icon: <Truck size={16} /> },
    ];

    // Determine current tab based on path if activeTabId is not provided
    const currentPath = location.pathname;
    const currentTab = activeTabId || tabs.find(tab => currentPath === tab.path)?.id || 'tables';

    return (
        <div className="qr-nav-container">
            <div className="qr-header">
                <div className="header-left">
                    <h1>QR Salle</h1>
                    <p>{subtitle || 'Centralisation du service en salle.'}</p>
                </div>
                {addButtonText && (
                    <button className="btn-add-qr" onClick={onAddClick}>
                        <Plus size={18} className="d-md-none" />
                        <span className="d-none d-md-inline">{addButtonText}</span>
                    </button>
                )}
            </div>

            <div className="qr-tabs-container">
                <div className="qr-tabs-box">
                    {tabs.map((tab) => (
                        <div
                            key={tab.id}
                            className={`qr-tab-item ${currentTab === tab.id ? 'active' : ''}`}
                            onClick={() => onTabChange ? onTabChange(tab.id) : navigate(tab.path)}
                        >
                            <span className="tab-icon">{tab.icon}</span>
                            <span className="tab-label">{tab.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

QRNav.propTypes = {
    activeTabId: PropTypes.string,
    subtitle: PropTypes.string,
    addButtonText: PropTypes.string,
    onAddClick: PropTypes.func,
    onTabChange: PropTypes.func,
};

export default QRNav;
